import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
//
import { ButtonCellRendererComponent } from './button-cell-renderer.component';
import { CheckboxCellRendererComponent } from './checkbox-cell-renderer.component';
import { CheckboxHeaderCellRendererComponent } from './checkbox-header-cell-renderer.component';
import { EditCellRendererComponent } from './edit-cell-renderer.component';
import { DocnameCellRendererComponent } from './docname-cell-renderer.component';
import { OrderCellRendererComponent } from './order-cell-renderer.component';



@NgModule({
  declarations: [
    ButtonCellRendererComponent,
    CheckboxCellRendererComponent,
    CheckboxHeaderCellRendererComponent,
    EditCellRendererComponent,
    DocnameCellRendererComponent,
    OrderCellRendererComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
  ],
  exports:[
    ButtonCellRendererComponent,
    CheckboxCellRendererComponent,
    CheckboxHeaderCellRendererComponent,
    EditCellRendererComponent,
    DocnameCellRendererComponent,
    OrderCellRendererComponent
  ]
})
export class GridCellModule { }
